import axios from 'axios'
import VueCookies from 'vue-cookies'
import { _getRefreshToken, _resetAuthData, _setAuthData } from "./utils"
import { API_URL } from "../env"
import $store from "../store"

export default async function callRefreshToken() {
    const refreshToken = _getRefreshToken()
    if (!refreshToken)
        return _resetAuthData()
    try {
        VueCookies.set('isRefreshingToken', 'true')
        console.log('refreshing token...')
        const refresh = await axios.post(`${API_URL}/auth/refresh?admin=true`, { token: refreshToken }, { timeout: 30000 })
        if (refresh.status === 200) {
            const data = refresh.data
            await _setAuthData({
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
                expireIn: data.expires_in
            }, true)
        } else {
            VueCookies.set('isRefreshingToken', 'false')
            return _resetAuthData()
        }
        VueCookies.set('isRefreshingToken', 'false')
    } catch (e) {
        VueCookies.set('isRefreshingToken', 'false')
        console.log(e)
        return _resetAuthData()
    }

}